import { useCallback } from 'react'
import { useCookies } from 'react-cookie'

const SESSION_KEY = '@you:sessionId'

const useReactCookies = () => {
  const [cookies, setCookie, removeCookie] = useCookies(['sessionId'])

  const clear = useCallback(() => {
    removeCookie('sessionId', { path: '/' })
    sessionStorage.removeItem(SESSION_KEY)
  }, [removeCookie])

  const get = useCallback(() => {
    const session = sessionStorage.getItem(SESSION_KEY)
    if (session) {
      try {
        return JSON.parse(session)
      } catch {
        return session
      }
    }

    const key = cookies.sessionId
    if (key) {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(key))
      return key
    }

    return
  }, [cookies.sessionId])

  const save = useCallback(
    v => {
      const date = new Date()
      date.setDate(date.getDate() + 1)
      setCookie('sessionId', v, {
        expires: date,
        path: '/',
        sameSite: 'strict',
        secure: true
      })
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(v))
    },
    [setCookie]
  )

  return {
    clear,
    get,
    save
  }
}

export default useReactCookies
